const IP_URL = process.env.REACT_APP_NODE_API_URL

export const getShiftAndHours = async (actual_datetime, shift, application_id) => {
  try {
    const response = await fetch(
      IP_URL + "api_components/get_shift_info",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          datetime: actual_datetime,
          shift: shift,
          application_id: application_id
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const getTravels = async (
  shift_date,
  truck_id_list,
  shovel_id_list,
  origin_id_list,
  destination_id_list,
  material_id_list,
  shift_list,
  travel_type_list,
  application_id
) => {
  try {
    const response = await fetch(
      IP_URL + "api_travels/all_travels",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          shift_date: shift_date,
          truck_id_list: truck_id_list,
          shovel_id_list: shovel_id_list,
          origin_id_list: origin_id_list,
          destination_id_list: destination_id_list,
          material_id_list: material_id_list,
          shift_list: shift_list,
          travel_type_list: travel_type_list,
          application_id: application_id
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const getTravelTypes = async (application_id) => {
  try {
    const response = await fetch(
      IP_URL + "api_travels/all_travel_types",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          application_id: application_id
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const getMaterial = async (application_id) => {
  try {
    const response = await fetch(
      IP_URL + "material/all_material",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
          application_id: application_id
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const getMaterialBlocks = async (application_id) => {
  try {
    const response = await fetch(
      IP_URL + "material/all_material_block",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
          application_id: application_id
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const getMaterialClass = async (application_id) => {
  try {
    const response = await fetch(
      IP_URL + "material/all_material_class",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
          application_id: application_id
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};

export const getPitLevel = async (application_id) => {
  try {
    const response = await fetch(
      IP_URL + "material/all_pit_levels",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
          application_id: application_id
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al iniciar sesión", error);
  }
};